/** zh-CN catalogue `lines` (W3-09; English: src/features/lines/lines.messages.ts; terms: docs/i18n/glossary.md). */
import type { MessageCatalog } from '../../core/util/types';

const TYPE =
  '{type, select, line {判定线} helper {辅助线} text {文字} image {图片} gif {GIF} paint {画笔} uiMover {UI 绑定线} other {{type}}}';
const ELEMENT =
  '{element, select, pause {暂停按钮} combonumber {连击数} combo {“COMBO”标签} score {分数} bar {进度条} name {曲名} level {难度等级} other {{element}}}';

const catalog: MessageCatalog = {
  ns: 'lines',
  locale: 'zh-CN',
  messages: {
    panelTitle: '判定线',
    panelHeading: '判定线（{total, number}）',
    panelHeadingFiltered: '判定线（{shown, number} / {total, number}）',
    treeLabel: '{count, plural, other {# 条判定线}}',
    noProjectTitle: '没有打开的谱面',
    noProject: '打开一张谱面以查看其判定线。',
    emptyTitle: '此谱面还没有判定线',
    emptyBody: '判定线承载音符并带着它们移动。添加一条判定线即可开始。',
    noMatchTitle: '没有匹配的判定线',
    noMatchBody: '没有判定线符合搜索和筛选条件。清除它们即可查看所有判定线。',
    add: '添加',
    addMenuLabel: '添加判定线',
    viewLabel: '判定线顺序',
    viewTree: '树状',
    viewOrder: '导出顺序',
    searchLabel: '按名称或编号搜索判定线',
    searchPlaceholder: '名称或 #编号',
    colToggles: '显示、独显和锁定',
    colName: '名称',
    colType: '类型',
    colNotes: '音符',
    colNow: '当前',
    colNowHelp: '在播放头处有动画。虚影表示 Phira 此刻不会为该判定线绘制任何内容。',
    colZHelp: '绘制顺序（zOrder）：数字越大越靠上绘制。音符总是绘制在所有判定线之上。相同时按导出顺序。',
    colGroup: '分组',
    colIndex: '#',
    colIndexHelp: '导出序号（在谱面文件中的位置；RPE 判定线编号）',
    colZ: 'z',
    notApplicable: '-',
    imageSize: '{w} x {h} px',
    unnamed: '未命名',
    defaultLineName: '判定线 {index}',
    expand: '显示 {name} 的子线',
    collapse: '隐藏 {name} 的子线',
    renameLabel: '判定线 {index} 的新名称',
    typeName: TYPE,
    typeUi: `UI：${ELEMENT}`,
    uiElementName: ELEMENT,
    notesCount: '{count, plural, other {# 个音符}}',
    zLabel: '绘制顺序 {z}',
    groupDefault: '默认',
    tagColour: '编辑器颜色标签',
    lockedBadge: '已锁定',
    nowAnimating: '正在运动',
    nowNotDrawn:
      '此刻不绘制：{reason, select, alpha {其不透明度为 0 或更低} scale {其尺寸为 0} emptyText {其文字为空} uiMover {它改为移动一个显示元素} paintCleared {其画笔为 0 或更小，会清除其绘制内容} other {{reason}}}',
    badgeTurnsWithParent: '随父线旋转',
    badgeUnpin: '已固定为额外轨道。单击以取消固定。',
    badgeStopAlsoShow: '其音符以虚影显示在轨道中。单击以停止。',
    badgeFocusHitsounds: '打击音只来自此判定线',
    toggleHide: '在预览中隐藏',
    toggleShow: '在预览中显示',
    toggleSolo: '在预览中独显',
    toggleUnsolo: '取消独显',
    toggleLock: '锁定以防编辑',
    toggleUnlock: '解锁',
    contextLabel: '判定线操作',
    dropRoot: '拖放到此处以移除父线',
    previewDiffers: '预览与导出不同：{details}',
    diffHidden: '已隐藏 {count, plural, other {# 条判定线}}',
    diffSolo: '已独显 {count, plural, other {# 条判定线}}',
    diffMuted: '已静音 {count, plural, other {# 个层级}}',
    diffDimmed: '其他判定线已调暗',
    listJoin: '{a}、{b}',
    showAll: '显示全部',
    lockedCount: '已锁定 {count, plural, other {# 条判定线}}（只影响编辑；预览和导出不变）',
    alsoShowLabel: '同时显示',
    alsoShowAdd: '判定线…',
    alsoShowRemove: '不再显示 {line} 的音符',
    filtersLabel: '判定线筛选',
    chipVisibleNow: '当前可见',
    chipVisibleNowHelp: 'Phira 在播放头处绘制的判定线（RPE：VisL）',
    chipAnimatingNow: '正在运动',
    chipAnimatingNowHelp: '在播放头处有属性正在变化的判定线（RPE：OnEve）',
    chipHasNotes: '有音符',
    chipHasNotesHelp: '承载音符的判定线',
    chipGroup: '分组',
    chipGroupOne: '分组：{name}',
    chipGroupMany: '{count, number} 个分组',
    chipType: '类型',
    chipTypeMany: '{count, number} 种类型',
    filterOption: '{name}（{count, number}）',
    clearFilters: '清除筛选',
    menuAdd: '添加',
    menuDuplicate: '创建副本',
    dupWithNotes: '包含音符',
    dupWithoutNotes: '不含音符',
    dupWithChildren: '包含其子线',
    dupAsChild: '作为原判定线的子线',
    menuGroup: '分组',
    groupNone: '无分组（默认）',
    menuEditGroups: '编辑分组…',
    menuOrder: '顺序',
    focusHitsoundsOn: '只播放这些判定线的打击音',
    focusHitsoundsOff: '播放所有判定线的打击音',
    pinLane: '固定为额外轨道',
    unpinLane: '取消固定轨道',
    alsoShowOn: '在轨道中显示它们的音符',
    alsoShowOff: '不再显示它们的音符',
    compareLines: '比较判定线…',
    menuDelete: '{count, plural, =1 {删除判定线} other {删除 # 条判定线}}',
    cmdSwitcher: '转到判定线…',
    cmdShowPanel: '显示判定线面板',
    cmdAddLine: '添加判定线',
    cmdAddText: '添加文字线',
    cmdAddImage: '添加图片线…',
    cmdAddUiMover: '添加 UI 绑定线',
    cmdAddGif: '添加 GIF 线…',
    cmdAddPaint: '添加画笔线',
    cmdAddHelper: '添加辅助线（不可见的父线）',
    cmdAddMany: '新建 N 条判定线…',
    cmdAddRpe24: '添加 RPE 风格的 24 条判定线',
    cmdDuplicate: '创建判定线副本',
    cmdDuplicateActive: '创建当前判定线的副本',
    cmdDelete: '删除判定线',
    cmdPrev: '上一条判定线',
    cmdNext: '下一条判定线',
    cmdWheelSwitch: '用滚轮切换判定线',
    cmdToFront: '置于顶层',
    cmdToBack: '置于底层',
    cmdMoveUp: '在导出顺序中上移',
    cmdMoveDown: '在导出顺序中下移',
    cmdRename: '重命名判定线',
    cmdSetParent: '设置父线…',
    cmdDetach: '移除父线',
    cmdChangeType: '更改判定线类型…',
    cmdToggleHidden: '在预览中隐藏或显示判定线',
    cmdToggleSolo: '在预览中独显判定线',
    cmdToggleLock: '锁定或解锁判定线',
    cmdFocusHitsounds: '只播放这些判定线的打击音',
    cmdShowAll: '显示所有判定线（结束隐藏、独显、静音和调暗）',
    cmdUnlockAll: '全部解锁',
    cmdPinLane: '将判定线固定为额外轨道',
    cmdAlsoShow: '在轨道中显示该判定线的音符',
    cmdAlsoShowPick: '同时显示以下判定线的音符…',
    cmdCopy: '复制判定线',
    cmdCut: '剪切判定线',
    cmdPaste: '粘贴判定线',
    cmdSelectAll: '选中所有判定线',
    cmdGroups: '编辑判定线分组…',
    cmdSetGroup: '将判定线放入分组',
    cmdNewGroup: '新建判定线分组…',
    cmdToggleView: '判定线面板：树状视图',
    cmdClearFilters: '清除判定线筛选',
    cmdExpandAll: '显示所有子线',
    cmdCollapseAll: '隐藏所有子线',
    argElement: '显示元素',
    argGroupName: '分组名称',
    noLines: '此谱面没有判定线。',
    noLineSelected: '请先选中一条判定线（在判定线面板中单击它）。',
    oneLineOnly: '请只选中一条判定线。',
    noParent: '选中的判定线没有父线。',
    nothingHidden: '没有隐藏、独显、静音或调暗的内容。',
    nothingLocked: '没有锁定的判定线。',
    noFiltersOn: '没有开启的筛选。',
    nothingSelected: '没有选中的判定线。',
    lockedRefusal:
      '{count, plural, =1 {“{line}”已锁定。} other {这些判定线中有 # 条已锁定，包括“{line}”。}}请在判定线面板中用锁形图标解锁后再修改。',
    lockedChild: '“{line}”已锁定，而删除其父线会改变它（它会失去或更换父线）。请先在判定线面板中用锁形图标将其解锁。',
    lockedDescendant: '“{line}”已锁定，因此不能随它们一起删除。请先将其解锁，或选择其他选项。',
    wouldLoop: '无法这样做：那样“{line}”会成为自己的祖先（“{parent}”跟随它）。',
    lineGone: '此判定线已不存在。',
    switchedTo: '判定线 {line}',
    addedLines: '{count, plural, other {已添加 # 条判定线}}',
    deleted: '{count, plural, =1 {已删除 {line}} other {已删除 # 条判定线}}',
    copied:
      '{count, plural, other {已复制 # 条判定线}}。可在判定线面板中用“粘贴判定线”粘贴，也可以粘贴到另一张谱面中。',
    copiedKey: '{count, plural, other {已复制 # 条判定线}}。可在判定线面板中按 {keys} 粘贴，也可以粘贴到另一张谱面中。',
    pasted: '{count, plural, other {已粘贴 # 条判定线}}',
    pasteEmpty: '剪贴板为空。请先在判定线面板中复制判定线。',
    pasteNotLines: '剪贴板中是音符或关键帧，而不是整条判定线。请改为在轨道中粘贴。',
    assetsResolved: '粘贴的判定线使用的 {count, plural, other {# 个文件}}已添加到此项目。',
    notesMoved: '{count, plural, other {已将 # 个音符}}移到 {line}',
    typeChanged: `{line} 现在是：{type, select, line {判定线} text {文字} image {图片} gif {GIF} paint {画笔} uiMover {UI 绑定线} other {{type}}}`,
    txAddLine:
      '添加{type, select, line {判定线} helper {辅助线} text {文字线} image {图片线} gif { GIF 线} paint {画笔线} uiMover { UI 绑定线} other {判定线}}',
    txAddLines: '{count, plural, other {添加 # 条判定线}}',
    txDuplicate: '{count, plural, =1 {创建判定线副本} other {创建 # 条判定线的副本}}',
    txDelete: '{count, plural, =1 {删除判定线} other {删除 # 条判定线}}',
    txSetParent: '{count, plural, =1 {设置父线} other {设置 # 条判定线的父线}}',
    txDetach: '{count, plural, =1 {移除父线} other {移除 # 条判定线的父线}}',
    txReorder: '{count, plural, =1 {在导出顺序中移动判定线} other {在导出顺序中移动 # 条判定线}}',
    txRename: '将判定线重命名为“{name}”',
    txToFront: '{count, plural, =1 {将判定线置于顶层} other {将 # 条判定线置于顶层}}',
    txToBack: '{count, plural, =1 {将判定线置于底层} other {将 # 条判定线置于底层}}',
    txSetGroup: '{count, plural, =1 {更改判定线的分组} other {更改 # 条判定线的分组}}',
    txNewGroup: '新建分组“{name}”',
    txEditGroup: '编辑分组“{name}”',
    txDeleteGroup: '删除分组“{name}”',
    txPaste: '{count, plural, =1 {粘贴判定线} other {粘贴 # 条判定线}}',
    txTurnOn: '{line}：随父线旋转',
    txTurnOff: '{line}：不随父线旋转',
    txChangeType: '更改 {line} 的类型',
    txMoveNotes: '将 {count, plural, other {# 个音符}}移到 {line}',
    cancel: '取消',
    done: '完成',
    deleteTitle: '{count, plural, =1 {删除 {name}？} other {删除 # 条判定线？}}',
    deleteNothing: '这些判定线已不存在。',
    deleteNotes: '{notes, plural, other {# 个音符}}将随{count, plural, =1 {该判定线} other {这些判定线}}一起删除。',
    deleteNoNotes: '{count, plural, =1 {该判定线} other {这些判定线}}没有音符。',
    deleteChildren: '{count, plural, other {# 条子线：}}',
    policyDetach: '保持它们原位',
    policyDetachHelp: '它们会失去父线（解除），并保持自身的数值。',
    policyReparent: '将它们挂到此判定线的父线上',
    policyReparentHelp: '它们改为跟随 {parent}。',
    policyReparentNone: '此判定线没有父线，因此它们最终也没有父线（与解除相同）。',
    policySubtree: '一并删除',
    policySubtreeHelp: '还会再删除 {lines, plural, other {# 条判定线}}和 {notes, plural, other {# 个音符}}。',
    deleteConfirm: '{count, plural, =1 {删除判定线} other {删除 # 条判定线}}',
    deleteUndoable: '判定线以 ID 标识，因此不会悄悄重新编号其他判定线。此操作可以撤销。',
    parentTitle: '将 {line} 挂到 {parent}',
    parentTitleDetach: '移除 {line} 的父线',
    parentTitleMany: '{count, plural, other {将 # 条判定线挂到 {parent}}}',
    parentTitleDetachMany: '{count, plural, other {移除 # 条判定线的父线}}',
    parentHow: '判定线应如何移动？',
    parentHowMany: '这些判定线应如何移动？（每条各自处理）',
    turnMixed: '这些判定线中有些随父线旋转，有些不随。保持复选框不变即可保留现状。',
    keepNumbers: '保持其数值',
    keepNumbersHelp: '其自身的位置和角度保持不变，因此它在屏幕上会随新的父线移动（RPE 的行为）。',
    keepPlace: '保持其当前位置',
    keepPlaceHelp: '在播放头处将其位置换算到父线的坐标系中，因此不会跳动。',
    keepPlaceAnimated:
      '{line} 随时间运动：只有播放头处或之后的位置关键帧会被换算到父线的坐标系中。之后请检查其附近的运动。',
    turnWithParent: '随父线旋转',
    turnOffCaption: '关：只有位置跟随',
    turnOnCaption: '开：其自身的角度也会旋转',
    turnSentence: '子线的位置总会随父线的旋转而绕转。此选项只决定子线自身的角度是否也一起旋转。',
    notInherited: '不透明度、颜色、尺寸和流速永远不会从父线继承。',
    parentConfirm: '挂接',
    parentConfirmDetach: '移除父线',
    typeTitle: '{line} 的判定线类型',
    typeDescription: 'Phira 根据判定线的图片以及文字、画笔和 GIF 关键帧来决定如何绘制它。',
    typeCurrent: `当前：${TYPE}`,
    typeHelp:
      '{type, select, line {普通的判定线。} text {显示可随时间变化的文字。} image {显示一张图片（RPE 需要 PNG 或 JPG）。} gif {自动或按关键帧播放 GIF。} paint {移动时用画笔绘制。} uiMover {移动一个游戏显示元素；没有音符。} other {}}',
    typeApply: `更改为${TYPE}`,
    typeBlocked: '请先完成上方的选择。',
    typeUnchanged: '该判定线已经是此类型。',
    lossIntro: '此更改会移除：',
    lossText: '文字关键帧（{count, number} 个）',
    lossPaint: '画笔关键帧（{count, number} 个）',
    lossGifTrack: 'GIF 进度关键帧（{count, number} 个）：在其他图片类型上 Phira 无法加载 GIF 进度',
    lossGifAuto: 'GIF 的“自动播放”',
    lossTexture: '图片“{path}”',
    lossElement: `显示元素（${ELEMENT}）`,
    lossUndo: '此更改可以撤销。',
    gainAlpha: '会添加 100% 不透明度：否则该显示元素在 Phira 中将不可见。',
    gainGifAuto: 'GIF 会从头开始自动播放（添加 GIF 进度关键帧即可控制它）。',
    gainText: '会添加一条文字轨道。',
    gainPaint: '会添加一条画笔轨道（10 px）。',
    pickImage: '图片',
    pickGif: 'GIF',
    pickElement: '显示元素',
    noImages: '此项目还没有图片。',
    noGifs: '此项目没有 Phira 能播放的 GIF。',
    addPicture: '添加图片…',
    addPictureHelp: '向项目添加 PNG 或 JPG（GIF 线则为 GIF），然后在此选择它。',
    addPictureUnavailable: '暂时无法添加图片。请使用素材面板。',
    initialText: '文字',
    initialTextPlaceholder: '文字',
    uiMoverNotes:
      '{line} 有 {count, plural, other {# 个音符}}。绑定了显示元素的判定线上的音符永远不会被绘制：请先把它们移到另一条判定线上。',
    noOtherLine: '没有其他可以移入的判定线。请先添加一条判定线。',
    moveNotesTo: '移到',
    moveNotes: '{count, plural, other {移动 # 个音符}}',
    switcherTitle: '转到判定线',
    switcherInput: '判定线名称或编号',
    switcherPlaceholder: '输入名称或 #编号',
    switcherCount: '{count, plural, =0 {没有匹配的判定线} other {# 条判定线}}',
    switcherNoIndex: '没有 #{index} 号判定线：此谱面共有 {count, plural, other {# 条判定线}}。',
    pickParentTitle: '{count, plural, =1 {选择父线} other {为 # 条判定线选择父线}}',
    pickAlsoShowTitle: '在轨道中显示另一条判定线的音符',
    pickerNoParent: '无父线',
    pickerCurrent: '当前',
    pickerWouldLoop: '会形成循环',
    pickerActive: '当前判定线',
    pickerShown: '已显示',
    newLinesTitle: '新建判定线',
    newLinesCount: '数量',
    newLinesCountRange: '一次请创建 1 到 {max, number} 条判定线。',
    newLinesPattern: '名称',
    newLinesPatternHelp: "'{k}' 从 0 开始计数，'{n}' 从 1 开始。两者都没有时，会自动添加编号。",
    newLinesPreview: '{names}{more, plural, =0 {} other {等另外 # 条}}',
    newLinesType: '类型',
    newLinesParent: '父线',
    newLinesCreate: '{count, plural, other {创建 # 条判定线}}',
    newImageTitle: '新建图片线',
    newImageHelp: '选择图片。Phira 会将其居中于判定线的位置。',
    newGifTitle: '新建 GIF 线',
    newGifHelp: '选择 GIF。在添加 GIF 进度关键帧之前，它会自动播放。',
    newUiMoverTitle: '新建 UI 绑定线',
    newUiMoverHelp: '选择该判定线要移动的显示元素。判定线本身及其音符都不会被绘制。',
    groupsTitle: '判定线分组',
    groupsDescription: '分组会写入谱面（RPE judgeLineGroup）。颜色仅用于编辑器。',
    groupsEmpty: '还没有分组：所有判定线都在“默认”中。',
    groupColour: '{name} 的颜色',
    groupNameOf: '{name} 的名称',
    groupLines: '{count, plural, other {# 条判定线}}',
    groupShowOnly: '只显示 {name} 中的判定线',
    groupMoveUp: '上移 {name}',
    groupMoveDown: '下移 {name}',
    groupFirst: '已经是第一个分组。',
    groupLast: '已经是最后一个分组。',
    groupDelete: '删除分组 {name}',
    groupDeleteTitle: '删除分组“{name}”？',
    groupDeleteBody: '其中的 {count, plural, other {# 条判定线}}会回到“默认”。此操作可以撤销。',
    groupDeleteConfirm: '删除分组',
    groupDeleted: '已删除分组“{name}”',
    newGroupName: '新分组',
    newGroupPlaceholder: '分组名称',
    newGroupAdd: '添加分组',
    newGroupNeedsName: '请先输入名称。',
    newGroupWithSelection: '{count, plural, =1 {将选中的判定线放入其中} other {将选中的 # 条判定线放入其中}}',
    noActiveLine: '无判定线',
    activeChipLabel: '当前判定线：{line}。打开判定线切换器。',
    activeChipTip: '当前判定线：单击以切换',
    paletteTitle: '#{index} {name}',
    paletteDetail: `${TYPE}{notes, plural, =0 {} other {，# 个音符}}{hasGroup, select, yes {，{group}} other {}}`,
    settingView: '判定线面板顺序',
    settingViewHelp: '树状显示父线和子线；导出顺序按写入谱面的顺序列出判定线。',
    helpPanelTitle: '判定线面板',
    helpPanelBody:
      '谱面的所有判定线。单击一条判定线即可编辑，按住 Ctrl 或 Shift 单击可选中多条。眼睛、独显和锁定按钮只改变预览和编辑，永远不影响导出。可用标签筛选，或按名称、#编号搜索。在任何地方按 L 即可跳到某条判定线。',
    helpParentsTitle: '父线',
    helpParentsBody:
      '将一条判定线拖到另一条上即可让它跟随那条判定线，或使用“设置父线”。子线的位置总会随父线的旋转而绕转；“随父线旋转”决定其自身的角度是否也一起旋转。不透明度、颜色、尺寸和速度永远不会继承。',
    helpTypesTitle: '判定线类型',
    helpTypesBody:
      'Phira 根据判定线的图片和关键帧，将其绘制为普通判定线、图片、GIF、文字或画笔。UI 绑定线会移动一个游戏显示元素，而不绘制自身。使用“更改判定线类型”更改类型；对话框会说明此更改会移除什么。',
  },
};

export default catalog;
